/* Sul Cuore · Luce del Sud (31/10/2026). Uma coisa se move por vez: cada seção entra uma vez ao chegar na tela.
   Cabeçalho (fio ao rolar) e gaveta do menu continuam no ap.js. */
(() => {
  const els = [...document.querySelectorAll('.lc-rv')];
  if (!els.length) return;
  const reduz = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduz || !('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('is-in')); return; }
  const io = new IntersectionObserver((ents) => {
    ents.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
  els.forEach(e => io.observe(e));
})();
